<app-header></app-header>
<br />
<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css" rel="stylesheet">
<div class="container">

    <!-- Page header start -->
    <div class="page-title">
        <div class="row gutters">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <h5 class="title">All Blogger's Chat</h5>
            </div>
        </div>
    </div>
    <!-- Page header end -->

    <!-- Content wrapper start -->
    <div #scroller class="content-wrapper">

        <!-- Row start -->
        <div class="row gutters">

            <div class="col-12">

                <div class="card m-0">

                    <!-- Row start -->
                    <div class="row no-gutters">
                        <div class="col-12">
                            <div class="chat-container">
                                <ul class="chat-box chatContainerScroll">
                                    <ng-container *ngFor="let item of items | async">
                                        <li class="chat-left" *ngIf="item.user!=userName">
                                            <div class="chat-avatar">
                                                <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                                                    alt="Retail Admin">
                                                <div class="chat-name">{{item.user}}</div>
                                            </div>
                                            <div class="chat-text" [innerHtml]="item.message">
                                            </div>
                                            <div class="chat-hour">{{item.date}} <span class="fa fa-check-circle"></span></div>
                                        </li>
                                        <li class="chat-right" *ngIf="item.user === userName">
                                            <div class="chat-hour">{{item.date}}<span class="fa fa-check-circle"></span></div>
                                            <div class="chat-text" [innerHtml]="item.message">
                                            </div>
                                            <div class="chat-avatar">
                                                <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                                                    alt="Retail Admin">
                                                <div class="chat-name">{{item.user}}</div>
                                            </div>
                                        </li>
                                    </ng-container>
                                </ul>

                            </div>
                        </div>
                    </div>
                    <!-- Row end -->
                </div>

            </div>

        </div>
        <!-- Row end -->

    </div>
    <!-- Content wrapper end -->
    <div>
        <quill-editor [(ngModel)]="msg" placeholder="Enter Message Here" required>
        </quill-editor>
        <br />
        <button (click)="onSubmit()"  class="button" mat-raised-button color="primary">Send Message <mat-icon aria-hidden="false"
                aria-label="Example home icon">send</mat-icon></button>
        <br />
    </div>
</div>